import type { DealHistorySnapshotDto } from 'apis/exclusive-deals';

export type SnapshotField = keyof DealHistorySnapshotDto;

/**
 * Compare a history snapshot with the previous (older) one and return the set
 * of fields whose values changed. With no older snapshot to compare against
 * (oldest entry on the page), nothing is marked as changed.
 */
export function diffDealSnapshots(
  current: DealHistorySnapshotDto,
  older: DealHistorySnapshotDto | undefined
): Set<SnapshotField> {
  const changed = new Set<SnapshotField>();
  if (!older) return changed;

  (Object.keys(current) as SnapshotField[]).forEach((field) => {
    if (current[field] !== older[field]) changed.add(field);
  });

  return changed;
}
